import React from "react";
import "../COMPONENTS/CSS/SliderLine.css";

const SliderLine = () => {
  const text =
    "elegance, where every thread carries tradition and every design tells a story.";

  return (
    <div className="scroll-line">
      <div className="scroll-line-track">
        <div className="scroll-line-group">
          <span>{text}</span>
        </div>

        <div className="scroll-line-group" aria-hidden="true">
          <span>{text}</span>
        </div>
      </div>
    </div>
  );
};

export default SliderLine;